export const OLD_SDK = 'https://cdn.riskid.security/sdk/web_sdk_latest.js'
export const SDK =
	'https://platform-websdk.transmitsecurity.io/platform-websdk/1.x/ts-platform-websdk.js'
export const SERVER_PATH = '/e/api.eu.transmitsecurity.io/risk-collect/'
